import { useSelector } from "react-redux";
import styled from "styled-components";
import { Paper as MuiPaper, Grid, Typography } from "@mui/material";

const Paper = styled(MuiPaper)`
  margin: 2px 10px;
  padding: 15px 10px;
`;

const GridContainer = styled(Grid)`
  height: 100%;
  align-items: center;
`;

export default function Footer() {
  const uiDetails = useSelector((state) => state.renderUIDetails);

  return (
    <Paper>
      <GridContainer container>
        <Grid item xs>
          {/* <Link color={colors.sprintexBlue} href="mailto:adtech@verismart.ai">
            Contact Us
          </Link> */}
        </Grid>

        <Grid item xs>
          <Typography variant="subtitle2" align="right">
            {`${uiDetails.siteCopyright} - © ${new Date().getFullYear()} `}
          </Typography>
        </Grid>
      </GridContainer>
    </Paper>
  );
}
